import elementIsNotNULL from "../../core/hooks/elementIsNotNULL";

/**
 * Shows or hides the specified element based on the value of isSpan.
 *
 * @param {string|HTMLElement} element - The element to show or hide.
 * @param {boolean} isSpan - A flag to determine if the element should be displayed inline-block.
 */
const showElement = function (element, isSpan) {
    // isSpan is introduced if element TagName is SPAN than it should be inline-block
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (elementIsNotNULL(element)) {
        if (!isSpan) {
            element.style.display = 'block';
        } else {
            element.style.display = 'inline-block';
        }
    }
};
export default showElement;
